import { render, staticRenderFns } from "./ServiceApply.vue?vue&type=template&id=32aa3c63&scoped=true"
import script from "./ServiceApply.vue?vue&type=script&lang=js"
export * from "./ServiceApply.vue?vue&type=script&lang=js"
import style0 from "./ServiceApply.vue?vue&type=style&index=0&id=32aa3c63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa3c63",
  null
  
)

export default component.exports